export default "__VITE_ASSET__DaItXC0j__"